import { TutorialTile } from "../../../../../shared/tutorial-tiles/model";

import TutorialAnimation from '../../../../../shared/tutorial-tiles/components/animations/Groups';

export const TUTORIAL_TILE_KEY = 'designer-catalog-groups';

export const tutorialTileConfig: TutorialTile = {
  titleI18nKey: 'tutorialTiles:designer:catalog:groups:title',
  image: TutorialAnimation,
  items: [
    {
      descriptionI18nKey: 'tutorialTiles:designer:catalog:groups:items:createGroup:description',
      icon: 'Add',
      titleI18nKey: 'tutorialTiles:designer:catalog:groups:items:createGroup:title',
    },
    {
      descriptionI18nKey: 'tutorialTiles:designer:catalog:groups:items:manualOrLogicGroups:description',
      icon: 'GroupList',
      titleI18nKey: 'tutorialTiles:designer:catalog:groups:items:manualOrLogicGroups:title',
    },
    {
      descriptionI18nKey: 'tutorialTiles:designer:catalog:groups:items:combineWithOtherAssets:description',
      icon: 'Shapes',
      titleI18nKey: 'tutorialTiles:designer:catalog:groups:items:combineWithOtherAssets:title',
    },
  ],
  showMeUrl: 'https://eyko.zendesk.com/hc/en-us/articles/1500010375802-Designer-Groups-Data-integrity-and-intelligence',
};
